import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Typography, Paper, Box, CircularProgress, Alert } from '@mui/material';
import axios from 'axios';

const Unsubscribe: React.FC = () => {
    const { guid } = useParams<{ guid: string }>();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        const unsubscribeUser = async () => {
            if (!guid) {
                setError('Invalid unsubscribe link.');
                setLoading(false);
                return;
            }

            try {
                // Use the generic base URL if available, otherwise assume same origin /api/email
                await axios.post(`/api/email/unsubscribe/${guid}`);
                setSuccess(true);
            } catch (err) {
                console.error('Error unsubscribing:', err);
                setError('We encountered an error while trying to unsubscribe you. Please try again later or contact support.');
            } finally {
                setLoading(false);
            }
        };

        unsubscribeUser();
    }, [guid]);

    return (
        <Container maxWidth="sm">
            <Box sx={{ mt: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Paper elevation={3} sx={{ p: 4, width: '100%', borderRadius: 2 }}>
                    <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                        Email Unsubscribe
                    </Typography>

                    {loading ? (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 4 }}>
                            <CircularProgress size={60} thickness={4} />
                            <Typography sx={{ mt: 2 }}>Processing your request...</Typography>
                        </Box>
                    ) : success ? (
                        <Box sx={{ py: 2 }}>
                            <Alert severity="success" sx={{ mb: 2 }}>
                                You have been successfully unsubscribed from our mailing list.
                            </Alert>
                            <Typography variant="body1" align="center">
                                We're sorry to see you go! You will no longer receive marketing or announcement emails from us.
                            </Typography>
                        </Box>
                    ) : (
                        <Box sx={{ py: 2 }}>
                            <Alert severity="error" sx={{ mb: 2 }}>
                                {error || 'An unexpected error occurred.'}
                            </Alert>
                            <Typography variant="body1" align="center">
                                If you believe this is an error, please reach out to our administration.
                            </Typography>
                        </Box>
                    )}
                </Paper>
            </Box>
        </Container>
    );
};

export default Unsubscribe;
